/**
 * Opens the Ithnain native app based on role.
 * Coach → educator app (ithnaineducator://), Patient/Caregiver → patient app (ithnain://).
 * If the app doesn't open within 500ms, redirects to the appropriate App Store / Play Store.
 */
export function redirectToApp(role: string): void {
  const roleLowercase = (role || "").trim().toLowerCase();
  const isEducator = roleLowercase === "coach";

  const appScheme = isEducator ? "ithnaineducator://" : "ithnain://";
  let iosAppStoreUrl: string;
  let androidPlayStoreUrl: string;

  if (isEducator) {
    iosAppStoreUrl =
      "https://apps.apple.com/app/ithnain-educator/id1498106036";
    androidPlayStoreUrl =
      "https://play.google.com/store/apps/details?id=com.ithnain.ithnaineducatorapp";
  } else {
    iosAppStoreUrl =
      "https://apps.apple.com/sa/app/ithnain-%D8%A5%D8%AB%D9%86%D9%8A%D9%86/id1478263137";
    androidPlayStoreUrl =
      "https://play.google.com/store/apps/details?id=com.ithnain.ithnainapp";
  }

  const userAgent =
    typeof navigator !== "undefined"
      ? navigator.userAgent || (navigator as Navigator & { vendor?: string }).vendor || ""
      : "";
  const isAndroid = /android/i.test(userAgent);

  const fallbackUrl = isAndroid ? androidPlayStoreUrl : iosAppStoreUrl;

  window.location.href = appScheme;

  setTimeout(() => {
    if (document.hasFocus()) {
      window.location.href = fallbackUrl;
    }
  }, 500);
}
